import dayjs from "dayjs"

import { TRANSFORMATION_TYPES } from "./supplierItemUtils"
import { COLORS, composes, roundNumber } from "../utils"
import { getSupplierItemName } from "../parseManager/productionStepExecutions/parseProductionStepExecutionManager"
import { START_HOUR, BLOCK_TIME, PSES_SIDEBAR_MENUS_ENUM, PSES_STATUS_TABS, DEFAULT_PSES_STATUS_TAB, SIDEBARS_WIDTH_STATUS_TABS, DEFAULT_SELECTED_PSES_SIDEBAR_MENU } from "./constant"
export { PSES_SIDEBAR_MENUS_ENUM, PSES_STATUS_TABS, DEFAULT_PSES_STATUS_TAB, SIDEBARS_WIDTH_STATUS_TABS, DEFAULT_SELECTED_PSES_SIDEBAR_MENU }

export const PSE_UPDATED_FROM = {
	CLIENT_STATUS_CHANGE: "clientStatusChange",
	CLIENT_INDIVIDUAL_STATUS_CHANGE: "clientIndividualStatusChange",
	CLIENT_MERGED_STATUS_CHANGE: "clientMergedStatusChange",
	CLIENT: "client",
}

export const PSES_SIDEBAR_WIDTH = {
	EXPANDED: 226,
	COLLAPSED: 88
}

// Scroll container shared by the PSE and packaging execution lists.
// minHeight:0 is required, otherwise the flex child keeps min-height:auto and overflowY never kicks in.
// The scrollbar is styled explicitly because iPadOS only shows a transient overlay one (KFC-427).
// No overscroll-behavior here on purpose: "contain" traps the wheel whenever this container has
// nothing left to scroll, instead of letting it chain to the page.
export const EXECUTIONS_SCROLL_SX = {
	minHeight: 0,
	overflowY: "auto",
	WebkitOverflowScrolling: "touch",
	scrollbarWidth: "thin",
	scrollbarColor: `${COLORS.BLACK_300} transparent`,
	"&::-webkit-scrollbar": {
		width: 10,
	},
	"&::-webkit-scrollbar-thumb": {
		backgroundColor: COLORS.BLACK_300,
		borderRadius: 8,
		border: "2px solid transparent",
		backgroundClip: "content-box",
	},
	"&::-webkit-scrollbar-track": {
		backgroundColor: "transparent",
	},
}
export const STEP_DATES = [
	{ value: -1, label: "J-1" },
	{ value: 0, label: "Jour J" },
	{ value: 1, label: "J+1" },
]

export const END_STEP_WEIGHING = [
	{ value: true, label: "Pesée nécessaire" },
	{ value: false, label: "Ne pas peser" }
]

export const DEFAULT_STEP_DATE = STEP_DATES[1].value

export const PSE_GENERATION_TYPE = {
	GENERATION: "GENERATION",
	REGENERATION: "REGENERATION"
}

export const PRODUCTION_STEP_EXECUTION_STATUSES_ENUM = {
	todo: "TODO",
	locked: "LOCKED",
	toTest: "TO_TEST",
	inProgress: "IN_PROGRESS",
	done: "DONE",
	cancelled: "CANCELLED"
}

export const PRODUCTION_STEP_EXECUTION_STATUSES = [
	{ value: PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.todo, name: "À démarrer" },
	{ value: PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.locked, name: "En attente" },
	{ value: PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.toTest, name: "À tester" },
	{ value: PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.inProgress, name: "En cours" },
	{ value: PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.done, name: "Terminée" },
	{ value: PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.cancelled, name: "Annulée" }
]

export const PSE_FLOWS_OPTIONS = {
	[PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.todo]: {
		color: "#BBDEFB",
		label: PRODUCTION_STEP_EXECUTION_STATUSES[0].name,
		icon: "todo"
	},
	[PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.locked]: {
		color: "#DBDBDB",
		label: PRODUCTION_STEP_EXECUTION_STATUSES[1].name,
		icon: "locked"
	},
	[PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.toTest]: {
		color: "#F1E7FF",
		label: PRODUCTION_STEP_EXECUTION_STATUSES[2].name,
		icon: "to-test"
	},
	[PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.inProgress]: {
		color: "#FBF4A5",
		label: PRODUCTION_STEP_EXECUTION_STATUSES[3].name,
		icon: "in-progress"
	},
	[PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.done]: {
		color: "#CEECD6",
		label: PRODUCTION_STEP_EXECUTION_STATUSES[4].name,
		icon: "done"
	},
	[PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.cancelled]: {
		color: "#FFCDD2",
		label: PRODUCTION_STEP_EXECUTION_STATUSES[5].name,
		icon: "cancelled"
	},
}

export const boPSETypesEnum = {
	UNPACKING: "UNPACKING",
	OTHERS: "OTHERS"
}


export const boPSETypeOptions = [
	{
		value: boPSETypesEnum.UNPACKING,
		label: "Déconditionnement"
	},
	{
		value: boPSETypesEnum.OTHERS,
		label: "Etapes de production"
	}
]

/**
 * Get color palette for a given PSE status
 * Main for header
 */
export const getPSEColorByStatus = (status) => {
	switch (status) {
		case PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.locked:
			return {
				main: "#F8F8F8",
				dark: "#9B9B9B",
			}
		case PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.todo:
			return {
				main: "#E3F2FD",
				dark: "#90C9F9",
			}
		case PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.inProgress:
			return {
				main: "#FDF0D2",
				dark: "#F2C046"
			}
		case PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.toTest:
			return {
				main: "#F1E7FF",
				dark: "#7900D9"
			}
		case PRODUCTION_STEP_EXECUTION_STATUSES_ENUM.done:
			return {
				main: "#EBF7EE",
				dark: "#89D69F"
			}
		default:
			return {
				main: "#E3F2F",
				dark: "#90C9F9",
			}
	}
}

export const findPSETypeOption = (value) => {
	return boPSETypeOptions.find(option => option.value === value)
}

export const PSES_SIDEBAR_MENUS_LABELS = {
	UNPACKING: "À déconditionner",
	COOKING: "À cuisiner",
	WEIGHING: "À peser",
	TASTING: "À goûter"
}

export const PSE_BLOCK_TYPES = {
	WEIGHTS: "weights",
	COOKING: "cooking",
	COOLING: "cooling",
	COOLING_END: "coolingEnd",
	PREPARATION: "preparation",
	INGREDIENTS: "ingredients",
}

export const getTabsBySidebareId = (sidebareId) => {
	switch (sidebareId) {
		case PSES_SIDEBAR_MENUS_ENUM.TASTING:
			return [PSES_STATUS_TABS.TODO, PSES_STATUS_TABS.DONE]
		case PSES_SIDEBAR_MENUS_ENUM.WEIGHING:
			return [PSES_STATUS_TABS.TODO, PSES_STATUS_TABS.IN_PROGRESS, PSES_STATUS_TABS.DONE]
		case PSES_SIDEBAR_MENUS_ENUM.COOKING:
			return Object.values(PSES_STATUS_TABS)
		default:
			return Object.values(PSES_STATUS_TABS)
	}
}


export const getPSEStatusLabel = (status) => {
	const currentOption = PRODUCTION_STEP_EXECUTION_STATUSES.find(option => option.value === status)
	if (!currentOption) {
		return ""
	}

	return currentOption.name
}

export const getStepDateLabelByValue = (value) => {
	const currentStepDate = STEP_DATES.find(stepDate => stepDate.value === value)
	return currentStepDate?.label
}

export const getEndStepWeighingLabelByValue = (value) => {
	const currentStepWeight = END_STEP_WEIGHING.find(stepWeight => stepWeight.value === value)
	return currentStepWeight?.label
}

/**
 * Check if a PSE is from overnight (Veille) based on night-related keywords in description or name.
 * Matches variations like "la nuit", "la nuite", "le nuit", "l nuit", etc.
 * @param {Object} productionStepExecution - PSE object (Parse object or JSON)
 * @returns {boolean} - true if PSE matches overnight criteria
 */
export const isPSEFromOvernight = (productionStepExecution) => {
	const snap = productionStepExecution.productionStepSnapshot ||
		(productionStepExecution.get && productionStepExecution.get("productionStepSnapshot"))

	if (!snap) return false

	// Match "la nuit", "la nuite", "le nuit", "l nuit", etc.
	const nightRegex = /l[ae]?\s*nuite?/i

	return (
		(snap.description && nightRegex.test(snap.description)) ||
		(snap.name && nightRegex.test(snap.name))
	)
}

export const formatProductionStepsHoursEditInitialValues = (productionStepExecutions) => {
	const values = productionStepExecutions.map((productionStepExecution) => ({
		objectId: productionStepExecution.objectId,
		theoreticalStartTime: productionStepExecution.theoreticalStartTime ? dayjs(productionStepExecution.theoreticalStartTime).format("HH:mm") : "",
		theoreticalEndTime: productionStepExecution.theoreticalEndTime ? dayjs(productionStepExecution.theoreticalEndTime).format("HH:mm") : "",
		name: productionStepExecution.productionStepSnapshot.name,
		transformationType: TRANSFORMATION_TYPES.find(t => t.value === (productionStepExecution.productionStepSnapshot.transformation || ""))?.label,
		machines: (productionStepExecution.machinesBatch || []).map((machine) => machine.machine.objectId) || [],
		machineOptions: productionStepExecution.machinesOptions || [],
		section: productionStepExecution?.section?.name,
		recipe: `${productionStepExecution?.recipe?.uniqueCode} - ${productionStepExecution?.recipe?.commercialName}`,
		status: productionStepExecution.status,
		...(productionStepExecution.mergedProductionStepExecutions && productionStepExecution.mergedProductionStepExecutions.length > 0) ? {
			section: productionStepExecution.mergedProductionStepExecutions[0].sectionName,
			recipe: productionStepExecution.mergedProductionStepExecutions.length + " recettes"
		} : {}
	}))

	return {
		productionStepsExecutions: values
	}
}

export const PSE_REGEX_HOURS = new RegExp(/^(?:[01]\d|2[0-3]):[0-5]\d$/)

export const editableHourToTimestamp = (hour, day) => {
	const [hours, minutes] = hour.split(":")
	const date = new Date(day)
	date.setHours(hours)
	date.setMinutes(minutes)
	return date.valueOf()
}

export const sortPSEByUniqueCode = (pseA, pseB) => {
	const uniqueCodeA = pseA.get ? pseA.get("uniqueCode") : pseA.uniqueCode
	const uniqueCodeB = pseB.get ? pseB.get("uniqueCode") : pseB.uniqueCode

	return uniqueCodeA && uniqueCodeB && uniqueCodeA.localeCompare(uniqueCodeB)
}

export const sortPSEBySectionName = (pseA, pseB) => {
	const sectionNameA = pseA.get ? pseA.get("sectionName") : pseA.sectionName
	const sectionNameB = pseB.get ? pseB.get("sectionName") : pseB.sectionName
	return sectionNameA && sectionNameB && sectionNameA.localeCompare(sectionNameB)
}

export const sortPSEByStepNumber = (pseA, pseB) => {
	const stepNumberA = pseA.get ? pseA.get("productionStepSnapshot").stepNumber : pseA.productionStepSnapshot.stepNumber
	const stepNumberB = pseB.get ? pseB.get("productionStepSnapshot").stepNumber : pseB.productionStepSnapshot.stepNumber
	return stepNumberA && stepNumberB && stepNumberA - stepNumberB
}

/**
 * Sort PSEs by respecting recipe order, section order, and workflow order within sections
 * @param {Object} pseA - First PSE to compare
 * @param {Object} pseB - Second PSE to compare
 * @returns {number} - Sort comparison result
 */
export const sortPSEByTheoreticalStartTime = (pseA, pseB) => {
	// Use pre-computed order if available
	const orderA = pseA.__sortOrder
	const orderB = pseB.__sortOrder

	if (orderA !== undefined && orderB !== undefined) {
		return orderA - orderB
	}

	// Fallback to basic comparison
	const uniqueCodeA = pseA.get ? pseA.get("uniqueCode") : pseA.uniqueCode
	const uniqueCodeB = pseB.get ? pseB.get("uniqueCode") : pseB.uniqueCode

	if (uniqueCodeA && uniqueCodeB && uniqueCodeA !== uniqueCodeB) {
		return uniqueCodeA.localeCompare(uniqueCodeB)
	}

	const sectionNameA = pseA.get ? pseA.get("sectionName") : pseA.sectionName
	const sectionNameB = pseB.get ? pseB.get("sectionName") : pseB.sectionName

	if (sectionNameA && sectionNameB) {
		return sectionNameA.localeCompare(sectionNameB)
	}

	// Final fallback: compare by stepNumber
	const stepNumberA = pseA.get ? pseA.get("productionStepSnapshot")?.stepNumber : pseA.productionStepSnapshot?.stepNumber
	const stepNumberB = pseB.get ? pseB.get("productionStepSnapshot")?.stepNumber : pseB.productionStepSnapshot?.stepNumber

	if (stepNumberA && stepNumberB) {
		return stepNumberA - stepNumberB
	}

	return 0
}

export const sortByTimeField = (pseA, pseB, timeFieldName) => {
	const pseAField = pseA.get ? pseA.get(timeFieldName) : pseA[timeFieldName]
	const pseBField = pseB.get ? pseB.get(timeFieldName) : pseB[timeFieldName]
	if (!pseAField && pseBField) {
		return 1
	}
	if (pseAField && !pseBField) {
		return -1
	}
	return pseAField - pseBField
}

/**
 * Sort PSEs using chain-based workflow ordering following the specified logic:
 * 1. Build chains across ALL PSEs (ignoring section boundaries)
 * 2. Determine section for each chain (from first non-merged PSE, or from merged PSEs' section)
 * 3. Find earliest theoretical start time for each chain
 * 4. Sort chains within each section
 * 5. Sort sections
 * 6. Flatten the result
 * @param {Array} pseList - Array of PSEs to sort
 * @returns {Array} - Sorted PSEs with __sortOrder assigned
 */
const sortPSEsByChains = (pseList) => {
	if (!Array.isArray(pseList) || pseList.length === 0) return []

	// STEP 1 & 2: Build chains across all PSEs, then group chains by section
	const chains = buildSectionChains(pseList) // Pass ALL PSEs, not sectioned

	// For each chain, determine its section
	const sectionChainData = []
	const sectionInfo = {}

	chains.forEach((chain, chainIndex) => {
		// Find the section for this chain (prefer non-merged PSEs)
		let sectionKey = null
		let sectionName = ""

		// Try to find a non-merged PSE first
		for (const pse of chain) {
			const isStepMerged = pse.get ? pse.get("isStepMerged") : pse.isStepMerged
			if (!isStepMerged) {
				const sectionPtr = pse.get ? pse.get("section") : pse.section
				const sectionId = sectionPtr?.id || sectionPtr?.objectId || null
				sectionName = (pse.get ? pse.get("sectionName") : pse.sectionName) || ""
				sectionKey = sectionId || sectionName || "_no_section"
				break
			}
		}

		// If all PSEs are merged, use the merged section
		if (!sectionKey) {
			const firstPSE = chain[0]
			const sectionPtr = firstPSE.get ? firstPSE.get("section") : firstPSE.section
			const sectionId = sectionPtr?.id || sectionPtr?.objectId || null
			sectionName = (firstPSE.get ? firstPSE.get("sectionName") : firstPSE.sectionName) || ""
			sectionKey = sectionId || sectionName || "_no_section"
		}

		// Record section info
		if (!sectionInfo[sectionKey]) {
			sectionInfo[sectionKey] = { sectionName }
		}

		// STEP 3: Find earliest theoretical start time in this chain
		const times = chain
			.map(p => (p.get ? p.get("theoreticalStartTime") : p.theoreticalStartTime))
			.filter(t => t != null)
		const earliestTime = times.length ? Math.min(...times) : null

		sectionChainData.push({
			sectionKey,
			sectionName,
			chain,
			earliestTime,
			chainIndex
		})
	})

	// Group chains by section for section-level operations
	const chainsBySection = {}
	sectionChainData.forEach(chainData => {
		if (!chainsBySection[chainData.sectionKey]) {
			chainsBySection[chainData.sectionKey] = []
		}
		chainsBySection[chainData.sectionKey].push(chainData)
	})

	// STEP 4: Sort chains within each section
	const sectionSummaries = []
	Object.entries(chainsBySection).forEach(([sectionKey, chainsInSection]) => {
		const timedChains = chainsInSection.filter(c => c.earliestTime !== null)
		const untimedChains = chainsInSection.filter(c => c.earliestTime === null)

		// Sort timed chains by earliest time
		timedChains.sort((a, b) => a.earliestTime - b.earliestTime)

		// Combine: timed first, then untimed in natural order
		const sortedChains = [...timedChains, ...untimedChains]

		// Find earliest time for this section
		const sectionEarliestTime = timedChains.length > 0 ? timedChains[0].earliestTime : null

		sectionSummaries.push({
			sectionKey,
			sectionName: sectionInfo[sectionKey]?.sectionName || "",
			sortedChains,
			sectionEarliestTime
		})
	})

	// STEP 5: Sort sections
	const timedSections = sectionSummaries.filter(s => s.sectionEarliestTime !== null)
	const untimedSections = sectionSummaries.filter(s => s.sectionEarliestTime === null)

	// Sort timed sections by their earliest time
	timedSections.sort((a, b) => a.sectionEarliestTime - b.sectionEarliestTime)

	// Sort untimed sections by name for stability
	untimedSections.sort((a, b) => a.sectionName.localeCompare(b.sectionName))

	const sortedSections = [...timedSections, ...untimedSections]

	// STEP 6: Flatten the result
	const result = []
	sortedSections.forEach(sectionData => {
		sectionData.sortedChains.forEach(chainData => {
			// Maintain natural order within each chain
			result.push(...chainData.chain)
		})
	})

	// Assign sort order for comparator usage
	result.forEach((pse, index) => { pse.__sortOrder = index })

	return result
}

/**
 * @param {Array} productionStepsExecutions 
 * @returns {Array}
 */
export const sortPSEByTimeFields = (productionStepsExecutions) => {
	if (!productionStepsExecutions || !Array.isArray(productionStepsExecutions) || productionStepsExecutions.length === 0) return []

	// Pre-compute sort order for TODO/LOCKED PSEs using chain-based sorting
	// Cache status for each PSE to avoid repeated .get("status") calls
	const statusCache = productionStepsExecutions.map(pse => pse.get ? pse.get("status") : pse.status)

	const todoLockedPSEs = []
	const inProgressPSEs = []
	const donePSEs = []
	const toTestPSEs = []

	for (let i = 0; i < productionStepsExecutions.length; i++) {
		const status = statusCache[i]
		if (status === "TODO" || status === "LOCKED") {
			todoLockedPSEs.push(productionStepsExecutions[i])
		} else if (status === "IN_PROGRESS") {
			inProgressPSEs.push(productionStepsExecutions[i])
		} else if (status === "DONE") {
			donePSEs.push(productionStepsExecutions[i])
		} else if (status === "TO_TEST") {
			toTestPSEs.push(productionStepsExecutions[i])
		}
	}

	sortPSEsByChains(todoLockedPSEs)

	return [
		...todoLockedPSEs.sort(sortPSEByTheoreticalStartTime),
		...inProgressPSEs.sort((a, b) => sortByTimeField(a, b, "startTime")),
		...donePSEs.sort((a, b) => sortByTimeField(a, b, "endTime")),
		...toTestPSEs.sort((a, b) => sortByTimeField(a, b, "endTime"))
	]
}

export const sortPEByTimeFields = (packagingExecutions) => {
	return [
		...packagingExecutions.filter((pe) => ["LOCKED", "WEIGHT_TO_VALIDATE", "TODO"].includes(pe.get ? pe.get("status") : pe.status))
			.sort((a, b) => sortByTimeField(a, b, "theoreticalStartTime")),
		...packagingExecutions.filter((pe) => ["IN_PROGRESS", "WASTE_TO_WEIGHT", "PACKAGINGS_COUNTING"].includes(pe.get ? pe.get("status") : pe.status))
			.sort((a, b) => sortByTimeField(a, b, "startTime")),
		...packagingExecutions.filter((pe) => (pe.get ? pe.get("status") : pe.status) === "DONE")
			.sort((a, b) => sortByTimeField(a, b, "endTime"))
	]
}

export const formatInterval = (minutes) => {
	const interval = [Math.floor(minutes / 60).toString(), (minutes % 60).toString()]
	return interval[0].padStart(2, "0") + "h" + interval[1].padStart(2, "0")
}

export const getInterval = (from, to) => {
	const [hoursA, minutesA] = from.split(":")
	const [hoursB, minutesB] = to.split(":")
	const timeA = dayjs().hour(hoursA).minute(minutesA)
	const timeB = dayjs().hour(hoursB).minute(minutesB)
	const interval = timeB.diff(timeA, "minutes")

	if (interval < 0) {
		return formatInterval(24 * 60 + timeB.diff(timeA, "minutes"))
	}

	return formatInterval(interval)
}

export const getModalPSETitle = (endStepWeighing, isCooling, isCooking) => {
	if (isCooling) {
		let isCoolingTitle = "Saisissez l'heure à laquelle les produits ont terminé leur refroidissement et leur température"
		if (endStepWeighing !== false) {
			isCoolingTitle += ", et le poids réel en sortie."
		}

		return isCoolingTitle
	}
	if (isCooking) {
		let isCookingTitle = "Saisissez l'heure à laquelle les produits ont terminé leur cuisson et leur température"
		if (endStepWeighing !== false) {
			isCookingTitle += ", et le poids réel en sortie."
		}

		return isCookingTitle
	}

	if (endStepWeighing === false) {
		return "Êtes-vous sûr de vouloir terminer l'étape de production ?"
	}

	return "Saisissez le poids réel en sortie pour terminer l'étape de production."
}


export const getPriorStepData = (productionStepExecution) => {
	const priorStepData = []
	productionStepExecution.priorSteps && productionStepExecution.priorSteps.forEach(priorStep => {
		if (priorStep.realNetWeight && priorStep.step && priorStep.step.productionStepSnapshot) {
			priorStepData.push({
				realNetWeight: priorStep.realNetWeight,
				coeff: priorStep.step.coeff,
				stepIndex: priorStep.step.productionStepSnapshot.index
			})
		}
	})
	return priorStepData
}

export const PSE_SUBSTATUSES = {
	/** KFC-2268 hide lotsSelection case temporarily **/
	// lotsSelection: "LOTS_SELECTION",
	stepCompletion: "STEP_COMPLETION",
	temperatureValidation: "TEMPERATURE_VALIDATION",
	weightValidation: "WEIGHT_VALIDATION",
	insufficientWeight: "INSUFFICIENT_WEIGHT"
}

export const PSE_SUBSTATUSES_AND_LABELS = [
	// { value: PSE_SUBSTATUSES.lotsSelection, label: "Sélection des lots" },
	{ value: PSE_SUBSTATUSES.stepCompletion, label: "Réalisation de l'étape" },
	{ value: PSE_SUBSTATUSES.temperatureValidation, label: "Saisie de la température finale" },
	{ value: PSE_SUBSTATUSES.weightValidation, label: "Pesée" },
]

export const PSE_SUBSTATUSES_AND_LABELS_WITH_INSUFFICIENT_WEIGHT = [
	...PSE_SUBSTATUSES_AND_LABELS,
	{ value: PSE_SUBSTATUSES.insufficientWeight, label: "Quantité insuffisante" },
]

export const getPSESubStatusLabel = (subStatus) => {
	const currentOption = PSE_SUBSTATUSES_AND_LABELS_WITH_INSUFFICIENT_WEIGHT.find(option => option.value === subStatus)
	if (!currentOption) return ""

	return currentOption.label
}

export const isPSEInsufficientWeight = (subStatus) => {
	return subStatus === PSE_SUBSTATUSES.insufficientWeight
}

export const getPSEWeightGap = (productionStepExecution) => {
	return roundNumber(productionStepExecution.netWeight - productionStepExecution.theoreticalNetWeight, 2)
}

export const computeFirstSubStatus = (productionStepExecution) => {
	const applicableSubstatuses = filterPSESubstatuses(productionStepExecution)
	return applicableSubstatuses[0].value
}

export const calculateNextSubStatus = (productionStepExecution) => {
	const applicableSubstatuses = filterPSESubstatuses(productionStepExecution)
	const currentSubStatus = productionStepExecution.subStatus
	const currentSubStatusIndex = applicableSubstatuses.findIndex(substatus => substatus.value === currentSubStatus)
	// If the current substatus is no longer in the applicable list (e.g. a COOLING PSE that
	// was left in weightValidation state before the COOLING weighing default changed), treat it
	// as the last step so the user can confirm and proceed to TO_TEST / DONE.
	if (currentSubStatusIndex === -1 && currentSubStatus) {
		return null
	}
	const nextSubStatus = applicableSubstatuses[currentSubStatusIndex + 1] // 0 if there was none before
	return nextSubStatus ? nextSubStatus.value : null
}

export const filterPSESubstatusesByTransformationType = (transformationType) => {
	return (substatuses) => {
		if (!["COOKING", "COOLING"].includes(transformationType)) {
			return substatuses.filter(substatus => substatus.value !== PSE_SUBSTATUSES.temperatureValidation)
		}
		return substatuses
	}
}

export const filterPSESubStatusesByEndWeighing = (endWeighing) => {
	return (substatuses) => {
		if (endWeighing === false) {
			return substatuses.filter(substatus => substatus.value !== PSE_SUBSTATUSES.weightValidation)
		}
		return substatuses
	}
}

export const filterPSESubStatusesBySupplierItem = (hasSupplierItem) => {
	return (substatuses) => {
		if (!hasSupplierItem) {
			return substatuses.filter(substatus => substatus.value !== PSE_SUBSTATUSES.lotsSelection)
		}
		return substatuses
	}
}

export const filterPSESubstatuses = (pse) => {
	// const hasSupplierItem = pse.productionStepSnapshot.stepComponents.some(stepComponent => !!stepComponent.supplierItem)
	const snapshot = pse.productionStepSnapshot
	const transformation = snapshot.transformation
	// COOLING steps have temperature validation as their terminal checkpoint.
	// Weighing is an explicit opt-in: undefined → no weighing (requires endStepWeighing: true).
	// For all other transformations, weighing is the default: undefined → weighing required
	// (requires endStepWeighing: false to opt out), matching the recipe editor's default.
	const endWeighing = transformation === "COOLING" && snapshot.endStepWeighing !== true
		? false
		: snapshot.endStepWeighing
	const filteredStatuses = composes(
		filterPSESubstatusesByTransformationType(transformation),
		filterPSESubStatusesByEndWeighing(endWeighing),
		/** KFC-2268 hide lotsSelection case temporarily **/
		// filterPSESubStatusesBySupplierItem(hasSupplierItem)
	)(PSE_SUBSTATUSES_AND_LABELS)
	return filteredStatuses
}

/**
 * change the substatus of a PSE to weightValidation if the substatus is insufficientWeight
 * this is mainly used for the substatus progress bar
 * insufficentWeight is a substatus that is not displayed in the progress bar
 * use weightValidation instead
 * @param {*} pse 
 * @returns 
 */
export const forcePSESubStatusToWeightValidation = (pse) => {
	const newPse = { ...pse }
	if (isPSEInsufficientWeight(newPse.subStatus)) {
		newPse.subStatus = PSE_SUBSTATUSES.weightValidation
	}

	return newPse
}

export const updateSubStatusForLowNetWeight = (productionStepExecution) => {
	const netWeight = productionStepExecution.netWeight
	const theoreticalWeight = productionStepExecution.theoreticalWeight

	if (netWeight < theoreticalWeight * 0.95) {
		productionStepExecution.subStatus = PSE_SUBSTATUSES.weightValidation
	}

}

/**
 * Calculate 5% of the theoretical weight
 * @example getFivePercentTheoreticalWeight(200) // returns 10
 * @param {number} theoreticalWeight - The expected theoretical weight
 * @returns {number} - 5% of the theoretical weight
 */
const getFivePercentTheoreticalWeight = (theoreticalWeight) => {
	const newTheoreticalWeight = (5 * theoreticalWeight) / 100

	return newTheoreticalWeight
}

/**
 * Check if the net weight is insufficient compared to the theoretical weight
 * An insufficient weight is defined as being more than 5% below the theoretical weight
 * @example getInsufficientWeight(180, 200) // returns true
 * @param {number} netWeight - The actual net weight measured
 * @param {number} theoreticalWeight - The expected theoretical weight
 * @returns {boolean} - True if the net weight is insufficient, false otherwise
 */
export const getInsufficientWeight = (netWeight, theoreticalWeight) => {
	// Round both weights to 2 decimals to avoid precision issues with small volumes
	const roundedNetWeight = roundNumber(netWeight, 2)
	const roundedTheoreticalWeight = roundNumber(theoreticalWeight, 2)

	const weightDiff = roundedTheoreticalWeight - roundedNetWeight
	const fivePercentWeight = getFivePercentTheoreticalWeight(roundedTheoreticalWeight)

	return weightDiff > fivePercentWeight
}

export const handlePSEWeighingMergedError = (theoreticalNetWeight, pseTheoreticalNetWeightFilled, totalTheoreticalNetWeight) => {
	let errorMessage = null
	if (theoreticalNetWeight.length === 0) {
		errorMessage = "Veuillez indiquer la répartition de la quantité par recette en fonction du poids final pesé."
	} else if (pseTheoreticalNetWeightFilled !== 0) {
		const roundedTotalTheoreticalNetWeight = roundNumber((totalTheoreticalNetWeight || 0), 2)
		const roundedPseTheoreticalNetWeightFilled = roundNumber((pseTheoreticalNetWeightFilled || 0), 2)

		if (roundedPseTheoreticalNetWeightFilled < roundedTotalTheoreticalNetWeight) {
			errorMessage = "L’ensemble des quantités saisies est inférieur au poids final pesé."
		} else if (roundedPseTheoreticalNetWeightFilled > roundedTotalTheoreticalNetWeight) {
			errorMessage = "L’ensemble des quantités saisies est supérieur au poids final pesé."
		}
	}

	return errorMessage
}

export const getProductionNeedsWeights = (productionNeeds = []) => {
	if (productionNeeds.length <= 0) return 0
	const productionNeed = productionNeeds[0]
	const providedWeight = productionNeed.get ? productionNeed.get("providedWeight") : productionNeed.providedWeight
	const initialNeededWeight = productionNeed.get ? productionNeed.get("initialNeededWeight") : productionNeed.initialNeededWeight
	return {
		initialNeededWeight: roundNumber(initialNeededWeight, 2),
		providedWeight: roundNumber(providedWeight, 2),
	}
}

export const hasProductionSupplyStocks = (output, expected) => output < expected

export const formatPSERecipeLabel = (pse) => {
	let recipe = `${pse.uniqueCode} - ${pse.recipeName}` + `,${pse.sectionName}`
	if (pse.mergedProductionStepExecutions && pse.mergedProductionStepExecutions.length > 0) {
		recipe = pse.mergedProductionStepExecutions.map(pse => `${pse.uniqueCode} - ${pse.recipeName}` + `,${pse.sectionName}`)
	}

	return recipe
}

export const mergeUnpackingIngredientsDone = (ingredients = []) => {
	const mergedIngredients = []

	ingredients.forEach(item => {
		const existingIngredient = mergedIngredients.find(entry => entry.objectId === item.objectId)
		if (existingIngredient) {
			existingIngredient.productionStepExecutions = [...existingIngredient.productionStepExecutions, ...item.productionStepExecutions]
		} else {
			mergedIngredients.push(item)
		}
	})

	return mergedIngredients
}

export const getPSEMachinesWithSameType = (productionStepExecution, machineTypes = [], machines = []) => {
	const newMachines = []
	const pseMachineType = productionStepExecution.productionStepSnapshot.machineType

	if (pseMachineType) {
		// From the list of all machineTypes, we want to find those that are compatible
		// with the machineType used in the recipe. A compatible machineType is one that 
		// shares at least one transformationType with the pseMachineType.
		const matchingMachineTypes = machineTypes.filter(machineType => {
			return (
				machineType.transformationTypes &&
				machineType.transformationTypes.some(transformationType =>
					pseMachineType.transformationTypes.includes(transformationType)
				)
			)
		})

		const allowedMachineModelIds = matchingMachineTypes
			.flatMap(matchingMachineType => matchingMachineType.machineModels)
			.map(machineModel => machineModel?.objectId)

		for (const machine of machines) {
			const kitchenAreaMachineModel = machine.machineModel
			if (allowedMachineModelIds.includes(kitchenAreaMachineModel.objectId)) {
				newMachines.push(machine)
			}
		}
	}

	return newMachines
}

/**
 * If all prior steps linked to the given ulterior step are marked as "DONE",
 * update the ulterior step's status to "TODO" and save it.
 *
 * @param {Parse.Object} ulteriorStep - The step to update, if applicable.
 */
export const updateUlteriorStepIfAllUnpackingDone = async (ulteriorStep) => {
	if (!ulteriorStep) return

	const priorSteps = ulteriorStep.get("priorSteps") || []
	const allDone = priorSteps.every(prior => prior.step?.get("status") === "DONE")

	if (allDone) {
		ulteriorStep.set("status", "TODO")
		await ulteriorStep.save()
	}
}

/**
 * Extract unique values for a given field from a list of production step executions.
 * Handles special case for "machines" where the value is inside nested "machinesOptions".
 */
export const getPSEsHoursEditUniqueOptions = (values, field, isMachines = false) => {
	const steps = values?.productionStepsExecutions || []
	if (!Array.isArray(steps)) return []

	// Special case: extract unique machine names from "machinesOptions"
	if (isMachines) {
		return Array.from(
			new Set(
				steps.flatMap(step => step?.machineOptions?.map(machine => machine.name) || [])
			)
		).filter(Boolean)
	}

	// Generic case: extract unique values for the given field
	return Array.from(
		new Set(steps.map(step => step?.[field]))
	).filter(Boolean)
}
// Utility function to apply filtering logic to production step executions
// Used in ProductionStepsHoursEdit to determine which rows match the current set of filters
// Handles special cases like `machines` (stored as objectIds with labels) and `status` (converted to readable label)
export const applyPSEsHoursEditFilters = (values, filters, filterFields, productionStepExecutions, PRODUCTION_STEP_EXECUTION_STATUSES) => {
	return values.productionStepsExecutions?.filter((PSE, index) => {

		// Map status value to its label
		const statusLabel = PRODUCTION_STEP_EXECUTION_STATUSES.find(s => s.value === PSE.status)?.name || ""

		// Loop over all filter keys and check if each one matches
		return filterFields.every(({ key }) => {
			const val = filters[key]

			// If the filter is empty or not applied, this field matches
			if (!val || (Array.isArray(val) && val.length === 0)) return true

			// Custom logic for machines
			if (key === "machines") {
				const selectedMachineIds = PSE.machines || []
				const availableMachines = productionStepExecutions[index]?.machinesOptions || []

				// Link machine IDs to their names
				const machineNames = selectedMachineIds
					.map(id => availableMachines.find(opt => opt.objectId === id)?.name)
					.filter(Boolean)
					.map(name => name.toLowerCase())

				if (Array.isArray(val)) return val.some(v => machineNames.includes(v.toLowerCase()))
				return machineNames.some(name => name.includes(val.toLowerCase()))
			}

			// Custom logic for status (compare against label string)
			if (key === "status") {
				return statusLabel.toLowerCase().includes(val.toLowerCase())
			}

			// Default field matching (convert to string and lowercase)
			const fieldValue = PSE[key]?.toString()?.toLowerCase?.()
			return Array.isArray(val)
				? val.includes(PSE[key])
				: fieldValue?.includes(val.toString().toLowerCase())
		})
	})
}

// Depth-first traversal over a PSE productionStepSnapshot tree
// --> Traverse all adjacent stepComponents one by one and reach its deepest prior steps
// Collects ingredients into the provided array
export const getIngredientsFromPSESnapshot = async (node, pseId, productionDate, reusableCoeff = 1) => {
	// At first call, node is the root productionStepSnapshot
	// After, it becomes priorSteps objects (if existing)
	if (!node) return []
	const ingredients = []

	const stepComponents = node.stepComponents || []

	for (const stepComp of stepComponents) {
		// check if the stepComponent contains ingredients or priorSteps to descend into
		const supplierId = stepComp.supplierItem && (stepComp.supplierItem.id || stepComp.supplierItem.objectId) || null
		const hasSupplier = stepComp && stepComp.supplierItem && typeof supplierId === "string" && supplierId.length > 0
		const hasPrior = stepComp && stepComp.priorSteps

		// CASE A - Direct ingredients
		if (hasSupplier && !hasPrior) {
			const grossWeight = stepComp.grossWeight || 0
			const name = await getSupplierItemName(supplierId, stepComp)

			ingredients.push({
				// supplierItem: { __type: "Pointer", className: "SupplierItems", objectId: supplierId },
				name: name,
				grossWeight: grossWeight || 0,
			})
		}

		// CASE B - Descend into embedded priorSteps (another productionStepSnapshot-like object)
		if (hasPrior) {
			const nestedIngredients = await getIngredientsFromPSESnapshot(stepComp.priorSteps, pseId, productionDate, reusableCoeff)
			for (const ingredient of nestedIngredients) ingredients.push(ingredient)
		}
	}

	return ingredients
}

/**
 * Converts a planner time index to a timestamp in milliseconds
 */
export const convertBlockIndexToTimestamp = (blockIndex, baseDate = new Date()) => {
	if (blockIndex === undefined || blockIndex === null) return null

	// Calculate total minutes from start hour
	const totalMinutesFromStart = blockIndex * BLOCK_TIME

	// Create timestamp starting from START_HOUR of the base date
	const timestamp = dayjs(baseDate)
		.startOf("day")
		.add(START_HOUR, "hours")
		.add(totalMinutesFromStart, "minutes")
		.valueOf()

	return timestamp
}

/**
 * Converts a timestamp to a planner time block index
 */
export const convertTimestampToBlockIndex = (timestamp, baseDate = new Date()) => {
	if (!timestamp) return null

	const timestampDay = dayjs(timestamp)
	const baseDateDay = dayjs(baseDate).startOf("day").add(START_HOUR, "hours")

	// Calculate minutes difference from START_HOUR
	const minutesDiff = timestampDay.diff(baseDateDay, "minutes")

	// Convert to block index
	const blockIndex = Math.floor(minutesDiff / BLOCK_TIME)

	return blockIndex >= 0 ? blockIndex : null
}

/**
 * Returns an object mapping each recipe's uniqueCode to its earliest theoreticalStartTime.
 * Only includes recipes that have at least one valid theoreticalStartTime.
 * Used for sorting and grouping PSEs by recipe start time.
 */
export const getEarliestTheoreticalStartTimesByRecipe = (allPSEs) => {
	// Group theoreticalStartTimes by uniqueCode
	const grouped = allPSEs.reduce((acc, pse) => {
		const code = pse.get ? pse.get("uniqueCode") : pse.uniqueCode
		if (!code) return acc
		const time = pse.get ? pse.get("theoreticalStartTime") : pse.theoreticalStartTime
		if (!acc[code]) acc[code] = []
		if (time) acc[code].push(time)
		return acc
	}, {})

	// Map to { uniqueCode: earliestTime } for codes with at least one time
	return Object.fromEntries(
		Object.entries(grouped)
			.map(([code, times]) => [code, Math.min(...times)])
			.filter(([, minTime]) => minTime !== Infinity)
	)
}

// Build chains (not flattened) across all PSEs using ulteriorStep links
// Special handling: merged PSEs check mergedProductionStepExecutions for ALL ulterior steps
const buildSectionChains = (psesInSection = []) => {
	if (!Array.isArray(psesInSection) || psesInSection.length === 0) return []

	// Map PSE id -> PSE and collect all ulteriorStep ids
	const pseMap = new Map()
	const isUlteriorStep = new Set()
	const mergedUlteriorSteps = new Map() // PSE id -> array of ulterior PSE ids

	psesInSection.forEach(pse => {
		const id = pse.id || pse.objectId
		if (!id) return
		pseMap.set(id, pse)

		// Check if this is a merged PSE with multiple ulteriorSteps across recipes
		const isStepMerged = pse.get ? pse.get("isStepMerged") : pse.isStepMerged
		const mergedPSEs = pse.get ? pse.get("mergedProductionStepExecutions") : pse.mergedProductionStepExecutions

		if (isStepMerged && mergedPSEs && Array.isArray(mergedPSEs) && mergedPSEs.length > 0) {
			// Collect ALL unique ulterior steps from all merged recipe contexts
			const uniqueUlteriorIds = new Set()

			// Add the main ulteriorStep if it exists
			const mainUs = pse.get ? pse.get("ulteriorStep") : pse.ulteriorStep
			const mainUsId = mainUs && (mainUs.id || mainUs.objectId)
			if (mainUsId) uniqueUlteriorIds.add(mainUsId)

			// Add ulteriorSteps from each merged context
			mergedPSEs.forEach(mergedContext => {
				const mergedUs = mergedContext.ulteriorStep
				const mergedUsId = mergedUs && (mergedUs.id || mergedUs.objectId)
				if (mergedUsId) uniqueUlteriorIds.add(mergedUsId)
			})

			if (uniqueUlteriorIds.size > 0) {
				mergedUlteriorSteps.set(id, Array.from(uniqueUlteriorIds))
				uniqueUlteriorIds.forEach(usId => isUlteriorStep.add(usId))
			}
		} else {
			// Regular PSE with single ulteriorStep
			const us = pse.get ? pse.get("ulteriorStep") : pse.ulteriorStep
			const usId = us && (us.id || us.objectId)
			if (usId) isUlteriorStep.add(usId)
		}
	})

	// Roots are PSEs that are not referenced as ulteriorStep of others
	const roots = psesInSection.filter(pse => {
		const id = pse.id || pse.objectId
		return id && !isUlteriorStep.has(id)
	})

	const visited = new Set()
	const chains = []

	const followChainFrom = (start) => {
		const chain = []
		let current = start

		while (current) {
			const id = current.id || current.objectId
			if (!id || visited.has(id)) break
			visited.add(id)
			chain.push(current)

			// Check if this PSE has multiple ulterior steps (merged PSE)
			const multipleUlteriorIds = mergedUlteriorSteps.get(id)

			if (multipleUlteriorIds && multipleUlteriorIds.length > 0) {
				// Follow all branches and add them to this chain
				multipleUlteriorIds.forEach(usId => {
					const ulteriorPSE = pseMap.get(usId)
					if (ulteriorPSE && !visited.has(usId)) {
						const branchChain = followChainFrom(ulteriorPSE)
						// Add the branch to the current chain
						chain.push(...branchChain)
					}
				})
				break // Already followed all branches
			} else {
				// Regular single ulteriorStep
				const us = current.get ? current.get("ulteriorStep") : current.ulteriorStep
				const nextId = us && (us.id || us.objectId)
				current = nextId ? pseMap.get(nextId) : null
			}
		}

		return chain
	}

	// Build chains starting from roots first (natural order)
	roots.forEach(root => {
		const chain = followChainFrom(root)
		if (chain.length) chains.push(chain)
	})

	// Safety: any remaining unvisited PSEs become their own chains from their position forward
	psesInSection.forEach(pse => {
		const id = pse.id || pse.objectId
		if (!id || visited.has(id)) return
		const chain = followChainFrom(pse)
		if (chain.length) chains.push(chain)
	})

	return chains
}

export const formatPSETemperature = (machineBatch, type = "COOLING") => {
	if (type === "COOKING") {
		return machineBatch.endTemperature + " °C"
	}
	return "" + machineBatch.startTemperature + " °C - " + machineBatch.endTemperature + " °C"
}

/**
 * Clear specified temperature/time fields from a machine batch while preserving machine info
 * @param {Object} batch - Machine batch object
 * @param {Array} fieldsToRemove - Array of field names to remove
 * @returns {Object} A new batch object with specified fields removed
 */
const clearBatchFields = (batch, fieldsToRemove) => {
	const newBatch = {}

	// Copy all fields except the ones we want to remove
	Object.keys(batch).forEach(key => {
		if (!fieldsToRemove.includes(key)) {
			newBatch[key] = batch[key]
		}
	})

	return newBatch
}

/**
 * Clear specified temperature/time fields from all batches in machinesBatch array
 * @param {Array} machinesBatch - machinesBatch array
 * @param {Array} fieldsToRemove - Array of field names to remove
 * @returns {Array} Updated machinesBatch with specified fields removed
 */
export const clearMachineBatchFields = (machinesBatch, fieldsToRemove) => {
	return machinesBatch.map(batch => clearBatchFields(batch, fieldsToRemove))
}

export const getExecutionsSidebarColor = (isSelected = false) => {
	if (isSelected) {
		return COLORS.DOWNLOAD_DOCUMENT_BLUE
	}
	return COLORS.BLACK800
}

export const getUlteriorSteps = (productionStepExecution) => {
	const isStepMerged = productionStepExecution.isStepMerged
	const mergedPSEs = productionStepExecution.mergedProductionStepExecutions || []
	const steps = []
	const directUlteriorStep = productionStepExecution?.ulteriorStep
	if (directUlteriorStep) steps.push(directUlteriorStep)
	if (isStepMerged && mergedPSEs.length > 0 && steps.length === 0) {
		for (const mergedPSE of mergedPSEs) {
			const mergedUlteriorStep = mergedPSE.ulteriorStep
			if (mergedUlteriorStep) steps.push(mergedUlteriorStep)
		}
	}
	return steps
}